import { useEffect, useState } from "react";


/**
 * useFadeIn hook
 *
 * Lightweight presentation hook used to apply a temporary
 * "fade-in" CSS class when one or more dependencies change.
 *
 * This hook is UI-oriented only:
 * - No visibility or mounting logic
 * - No side effects outside of styling
 *
 * Typical use cases:
 * - Subtle visual feedback on data refresh
 * - Highlighting updated content
 * - Simple animations without external libraries
 *
 * Author: Samano CASTRE
 * Date: January 2026
 */
export const useFadeIn  = (
    duration : number, 
    ...deps : any[] ) => {

    /**
	 * Holds the current fade-in CSS class
	 */
    const [fadeInClass, setFadeInClass] = useState('');

    useEffect(() => {
        /**
		 * Applies the `fadein` class when dependencies change
		 * and automatically removes it after the specified duration.
		 *
		 * The timeout is cleared on cleanup to avoid stale updates
		 * during rapid re-renders or component unmounting.
		 */
        setFadeInClass('fadein');
        const timeout = setTimeout(() => setFadeInClass(''), duration);
        return () => clearTimeout(timeout);
    }, [...deps, duration]);

    return fadeInClass;
}